module.exports = __webpack_public_path__ + "static/media/User.69d2ed55.jpg";